var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, cloneElement } from 'react';
import styled from 'styled-components';
const RadioContainer = styled.fieldset `
  border: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  margin-top: auto;
  flex-direction: ${({ direction }) => direction};

  .sr-only {
    border: 0;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;
const Legend = ({ hideLegend, legend = React.createElement(React.Fragment, null) }) => typeof legend === 'string' ? (React.createElement("legend", { className: hideLegend && 'sr-only' }, legend)) : (cloneElement(legend, {
    className: [legend.props.className, hideLegend && 'sr-only']
        .filter(Boolean)
        .join(' ')
}));
const RadioGroup = (_a) => {
    var { legend, hideLegend, selected, onChange = () => { }, children, className, direction = 'column', radioType } = _a, props = __rest(_a, ["legend", "hideLegend", "selected", "onChange", "children", "className", "direction", "radioType"]);
    return (React.createElement(RadioContainer, Object.assign({}, props, { direction: direction, className: className }),
        React.createElement(Legend, { hideLegend: hideLegend, legend: legend }),
        Children.map(children, child => cloneElement(child, Object.assign(Object.assign({}, child.props), { checked: selected === child.props.value, direction,
            radioType, onChange: () => onChange(child.props.value) })))));
};
export default RadioGroup;
